// extracted by mini-css-extract-plugin
export default {"liked-page":"style_liked-page__YRyIn"};